import { ProgramService } from "@adfenix/types";
import { propertiesNonAdminsCanUpdateOnActivePrograms } from "atoms/programBuilder";
import { useCheckPermission } from "hooks/usePermissions";
import { useFormContext } from "react-hook-form";
import { useRecoilValueLoadable } from "recoil";

export const useDisabledFields = (): ((field: string) => boolean) => {
  const hasAdminEditPermission = useCheckPermission({
    scope: "ProgramAdmin",
    action: "Edit"
  });

  const { watch } = useFormContext<Partial<ProgramService.ProgramModel>>();

  const propsForNonAdmin = useRecoilValueLoadable(
    propertiesNonAdminsCanUpdateOnActivePrograms
  );

  return (field: string) => {
    if (hasAdminEditPermission) return false;

    const { active } = watch();

    if (!active) return false;

    if (propsForNonAdmin.state !== "hasValue") {
      return true;
    }

    return !propsForNonAdmin.contents.hasOwnProperty(field.toLocaleLowerCase());
  };
};
